import AccessTimeIcon from '@material-ui/icons/AccessTime';
import moment, { Moment } from 'moment';
import { useState } from 'react';
import useInterval from 'shared/hooks/useInterval';

interface WaitingClockTimerProps {
  startAt: Moment;
}

const formatElapsed = (totalSeconds: number): string => {
  const seconds = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return hours > 0
    ? `${pad(hours)}:${pad(minutes)}:${pad(secs)}`
    : `${pad(minutes)}:${pad(secs)}`;
};

const WaitingClockTimer = ({ startAt }: WaitingClockTimerProps) => {
  const [now, setNow] = useState(() => moment());

  useInterval(() => setNow(moment()), 1000);

  return (
    <div
      className="flex items-center gap-1 mt-1 text-xs font-semibold text-blue-600"
      title="Tiempo de espera en curso"
    >
      <AccessTimeIcon style={{ fontSize: 12 }} />
      <span>{formatElapsed(now.diff(startAt, 'seconds'))}</span>
    </div>
  );
};

export default WaitingClockTimer;
